export default {"src":"/org/_next/static/media/calendar.c3cf4956.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};